// Asks the push pre-prompt (components/Modals/PushPreprompt) to consider showing
// after a qualifying action succeeds: kind is order | alert | league. No imports,
// so the API layer can call it without a cycle.
export const PUSH_PREPROMPT_EVENT = "qushiPushPreprompt";

export function queuePushPreprompt(kind) {
  window.dispatchEvent(new CustomEvent(PUSH_PREPROMPT_EVENT, { detail: { kind } }));
}
